import { render } from "./price-form.vue?vue&type=template&id=0bffdc7e&scoped=true"
import script from "./price-form.vue?vue&type=script&lang=js"
export * from "./price-form.vue?vue&type=script&lang=js"

import "./price-form.vue?vue&type=style&index=0&id=0bffdc7e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bffdc7e"]])

export default __exports__